export const MESSAGE = {
    SAVED_CHAT_IMAGE: "SAVED_CHAT_IMAGE",
    IMAGE_EDITOR: "IMAGE_EDITOR",
    IMAGE_ROTATION: "IMAGE_ROTATION",
    TEXT_DETECTIONS: "TEXT_DETECTIONS",
    JSON_GRID: "JSON_GRID",
    EVENT_STARTED: "EVENT_STARTED",
    EVENT_FINISHED: "EVENT_FINISHED",
    REQUEST_CHAT_MODEL: "REQUEST_CHAT_MODEL",
    API_RESPONSE: "API_RESPONSE",
    CONTENT_WITH_IMAGES: "CONTENT_WITH_IMAGES",

    // Frontend
    // {"type": "DATE_CALENDAR", "date": "2024-04-17"}
    DATE_CALENDAR: "DATE_CALENDAR",
    IMAGE_WITH_LINK: "IMAGE_WITH_LINK",
    INDEXED_DB_RESPONSE: "INDEXED_DB_RESPONSE",
};

export const WS_MESSAGE = {
    SET_CHAT_ID: "SET_CHAT_ID",
    USER_TYPING: "USER_TYPING"
};

export const KB_TABS = {
    chat: 'chat',
    configuration: 'settings',
    items: 'database',
    code_studio: 'Code Studio',
    share_access: 'access',
};
